import {Injectable} from '@angular/core';
import {PasswordExpiryEnum} from '../password-expiry-key.enum';

@Injectable()
export class PasswordExpiry {
  expiryType: PasswordExpiryEnum;
  days?: number;
}
